import React from 'react';


// Material
import { Grid, GridList, GridListTile, GridListTileBar } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import ImageIcon from '@material-ui/icons/Image';
import { ClearAll } from '@material-ui/icons';
import CreateIcon from '@material-ui/icons/Create';

// reactstrap components
import {
    Button
} from "reactstrap";

// core components
import ImageUploading from 'react-images-uploading';
import LinearProgressWithLabel from "./LinearProgressWithLabel"
import { Fragment } from 'react';
import { LoadingPacman } from "../MiscFunctions"

export default function ImageUpload({ pictures, progress, maxNumber, setPictures, deleted, setDeleted, disabled = false }) {

    const onChange = (imageList) => {
        setPictures(imageList);
    };

    return (
        <div>
            <ImageUploading
                multiple
                value={pictures}
                onChange={onChange}
                maxNumber={maxNumber}
                dataURLKey="data_url"
            >
                {({
                    imageList,
                    onImageUpload,
                    onImageRemoveAll,
                    onImageUpdate,
                    onImageRemove,
                }) => (
                    <>
                        <GridList cols={3}>
                            {
                                typeof (imageList) !== "string" ?
                                    // Generates the preview
                                    imageList.map((image, index) => (
                                        <GridListTile key={index} className="image-item">
                                            <img src={image['data_url'] || image} alt="" style={{ minWidth: "100%", minHeight: "100%" }} />
                                            <GridListTileBar
                                                actionIcon={
                                                    <>
                                                        <Button
                                                            className="btn-just-icon"
                                                            color="info"
                                                            type="button"
                                                            onClick={() => onImageUpdate(index)}
                                                        >
                                                            <CreateIcon fontSize="small" />
                                                        </Button>
                                                        <Button
                                                            className="btn-just-icon"
                                                            color="danger"
                                                            type="button"
                                                            onClick={() => {
                                                                if (typeof (image) === "string") {
                                                                    const array = deleted.concat(image)
                                                                    setDeleted(array)
                                                                }
                                                                onImageRemove(index)
                                                            }}
                                                        >
                                                            <DeleteIcon fontSize="small" />
                                                        </Button>
                                                    </>
                                                }
                                            />
                                        </GridListTile>
                                    ))
                                    :
                                    // Categories only have 1 picture so you can't loop over it
                                    <GridListTile className="image-item">
                                        <img src={pictures['data_url'] || pictures} alt="" style={{ minWidth: "100%", minHeight: "100%" }} />
                                        <GridListTileBar
                                            actionIcon={
                                                <>
                                                    <Button
                                                        className="btn-just-icon"
                                                        color="info"
                                                        type="button"
                                                        onClick={() => onImageUpdate(0)}
                                                    >
                                                        <CreateIcon fontSize="small" />
                                                    </Button>
                                                    <Button
                                                        className="btn-just-icon"
                                                        color="danger"
                                                        type="button"
                                                        onClick={() => {
                                                            if (typeof (pictures) === "string") {
                                                                const array = deleted.concat(pictures)
                                                                setDeleted(array)
                                                            }
                                                            onImageRemove(0)
                                                        }}
                                                    >
                                                        <DeleteIcon fontSize="small" />
                                                    </Button>
                                                </>
                                            }
                                        />
                                    </GridListTile>
                            }
                        </GridList>
                        <LinearProgressWithLabel value={progress} />
                        <Grid container spacing={0}>
                            {/* The buttons */}
                            {
                                !disabled ?
                                    <Fragment>
                                        <Grid item style={{ paddingTop: "1%" }}>
                                            <Button
                                                component="span"
                                                className="btn-just-icon"
                                                color="info"
                                                type="button"
                                                size="lg"
                                                aria-label="add"
                                                onClick={onImageUpload}
                                            >
                                                <ImageIcon />
                                            </Button>
                                        </Grid>
                                        <Grid item style={{ paddingTop: "1%", paddingLeft: "1%" }}>
                                            <Button
                                                component="span"
                                                className="btn-just-icon"
                                                color="danger"
                                                type="button"
                                                size="lg"
                                                aria-label="add"
                                                onClick={() => {
                                                    onImageRemoveAll()
                                                    setDeleted(pictures)
                                                }}
                                                style={{ display: "flex", justifyContent: "center", alignItems: "center" }}
                                            >
                                                <ClearAll />
                                            </Button>
                                        </Grid>

                                    </Fragment>
                                    :
                                    <Fragment>
                                        <Grid item style={{ paddingTop: "1%", paddingLeft: "1%" }}>
                                            <Button
                                                component="span"
                                                className="btn-just-icon"
                                                color="danger"
                                                type="button"
                                                size="lg"
                                                aria-label="add"
                                                style={{ display: "flex", justifyContent: "center", alignItems: "center" }}
                                            >
                                            </Button>
                                        </Grid>
                                        <Grid item style={{ paddingTop: "1%", paddingLeft: "1%" }}>
                                            <LoadingPacman />
                                        </Grid>
                                    </Fragment>
                            }
                        </Grid>
                    </>
                )}
            </ImageUploading>
        </div>
    );
}